/*!
=========================================================
* Regiform IMS Frontend - Print Indicator Component
=========================================================
* Fixed bottom indicator showing ongoing print/PDF operations
* Stays visible even when scrolling (max 5px height)
=========================================================
*/

import { usePrintStore } from "../../stores/printStore";
import { LoadingOutlined, PrinterOutlined } from "@ant-design/icons";
import "./PrintIndicator.css";

const PrintIndicator = () => {
  const { printJobs } = usePrintStore();

  console.log("printJobs", printJobs);

  // Don't render if no print jobs
  if (printJobs.length === 0) {
    return null;
  }

  return (
    <div className="print-indicator">
      <div className="print-indicator-content">
        <LoadingOutlined className="print-indicator-icon" spin />
        <PrinterOutlined className="print-indicator-printer" />
        <span className="print-indicator-text">
          Printing in progress ({printJobs.length})
        </span>
      </div>
    </div>
  );
};

export default PrintIndicator;
